import React from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { cancelBooking } from 'redux/booking/car/carBookingSlice';
import { Modal, Button, Alert } from 'components/common';

const TransactionDetailCancelModal = ({ showModal, setshowModal, transaction }) => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const dispatch = useDispatch();

  const closeModal = () => setshowModal(false);

  const onSubmit = (data) => {
    try {
      dispatch(cancelBooking({ transactionId: transaction?.id, data }));
      closeModal();
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <Modal
      show={showModal}
      onHide={closeModal}
      title="Cancel car booking"
      size="lg"
      footer={(
        <>
          <Button size="sm" variant="secondary" onClick={closeModal}>No</Button>
          <Button size="sm" type="submit" form="cancel-car-booking-form" variant="primary">Yes</Button>
        </>
      )}
    >
      <form id="cancel-car-booking-form" onSubmit={handleSubmit(onSubmit)}>
        <Alert type="info" className="tw-mb-4">
          You are only allowed to cancel a booking when it has not been approved. You must specify the reason for the cancellation.
        </Alert>

        <label className="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Reason</label>
        <textarea
          rows={6}
          placeholder="Reason"
          className="tw-w-full tw-px-3 tw-py-2 tw-border tw-border-solid tw-border-slate-300 tw-rounded-md tw-text-sm tw-text-slate-900 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500"
          {...register('reason', { required: 'Reason must be required' })}
        />
        {errors.reason && <p className="tw-text-xs tw-text-red-600 tw-mt-1 tw-mb-0">{errors.reason.message}</p>}
      </form>
    </Modal>
  );
};

TransactionDetailCancelModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setshowModal: PropTypes.func.isRequired,
  transaction: PropTypes.object.isRequired,
};

export default TransactionDetailCancelModal;
